// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Label_settings .iq-user-box1 {
  margin-right: 10px;
  border-radius: 5px;
  padding: 2px;
  min-width: 35px;
  text-align: center;
  background: #20c997 !important;
}
.Label_settings .iq-user-box2 {
  margin-right: 10px;
  border-radius: 5px;
  padding: 2px;
  min-width: 35px;
  text-align: center;
  background: #24c0d9 !important;
}
.Label_settings .iq-user-box3 {
  margin-right: 10px;
  border-radius: 5px;
  padding: 2px;
  min-width: 35px;
  text-align: center;
  background: hsl(39deg 67.42% 58.25%) !important;
}
.Label_settings .iq-user-box4 {
  margin-right: 10px;
  border-radius: 5px;
  padding: 2px;
  min-width: 35px;
  text-align: center;
  background: #17a2b8 !important;
}
.Label_settings .iq-user-box5 {
  margin-right: 10px;
  border-radius: 5px;
  padding: 2px;
  min-width: 35px;
  text-align: center;
  background: #6c757d !important;
}

span.bg-warning.video_active {
  padding: 10px;
}

.Label_settings .nav-link.active {
  /* font-size: 16px; */
  border-bottom: 2px solid #006aff !important;
  font-weight: 500;
  color: #fff !important;
}
.Label_settings .nav-link {
  border-bottom: transparent;
  font-weight: 500;
  color: #000000;
  background-color: transparent;
  padding: 10px 60px;
}
.Label_settings .data_th {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  height: 65px;
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Site/Settings/Label_Settings/Main_labels.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,+CAA+C;AACjD;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,gCAAgC;EAChC,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".Label_settings .iq-user-box1 {\n  margin-right: 10px;\n  border-radius: 5px;\n  padding: 2px;\n  min-width: 35px;\n  text-align: center;\n  background: #20c997 !important;\n}\n.Label_settings .iq-user-box2 {\n  margin-right: 10px;\n  border-radius: 5px;\n  padding: 2px;\n  min-width: 35px;\n  text-align: center;\n  background: #24c0d9 !important;\n}\n.Label_settings .iq-user-box3 {\n  margin-right: 10px;\n  border-radius: 5px;\n  padding: 2px;\n  min-width: 35px;\n  text-align: center;\n  background: hsl(39deg 67.42% 58.25%) !important;\n}\n.Label_settings .iq-user-box4 {\n  margin-right: 10px;\n  border-radius: 5px;\n  padding: 2px;\n  min-width: 35px;\n  text-align: center;\n  background: #17a2b8 !important;\n}\n.Label_settings .iq-user-box5 {\n  margin-right: 10px;\n  border-radius: 5px;\n  padding: 2px;\n  min-width: 35px;\n  text-align: center;\n  background: #6c757d !important;\n}\n\nspan.bg-warning.video_active {\n  padding: 10px;\n}\n\n.Label_settings .nav-link.active {\n  /* font-size: 16px; */\n  border-bottom: 2px solid #006aff !important;\n  font-weight: 500;\n  color: #fff !important;\n}\n.Label_settings .nav-link {\n  border-bottom: transparent;\n  font-weight: 500;\n  color: #000000;\n  background-color: transparent;\n  padding: 10px 60px;\n}\n.Label_settings .data_th {\n  padding: 0.75rem;\n  vertical-align: middle;\n  border-top: 1px solid #dee2e6;\n  border-bottom: 1px solid #dee2e6;\n  height: 65px;\n  cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
